import React, { useState, useEffect } from 'react';
import Breadcrumb from './Breadcrumb';
import Footer from '../../components/footer/Footer';
import HeaderOne from '../../components/header/HeaderOne';
import { useAccount } from 'wagmi';
import Slider from 'react-slick';
import { getSpaceships } from '../../web3/SFM-SpaceshipUtils';
import { getWeapons } from '../../web3/SFM-WeaponUtils';
import { getShields } from '../../web3/SFM-ShieldUtils';
import { getRepairkits } from '../../web3/SFM-RepairKitUtils';
import constants from '../../constants';
import PromptLogin from '../PromptLogin';
import { PrevArrow } from '../../components/slider/prevArrow';
import { NextArrow } from '../../components/slider/nextArrow';
import SingleUserOwnedNFT from '../../components/NFTCards/SingleUserOwnedNFT';
import { NFTSTypes } from '../../data/nftsType';

function Portfolio() {
  const { isConnected, chain, address } = useAccount();
  const [nfts, setNfts] = useState([]);
  const [loadNfts, setLoadNfts] = useState(false);
  const [weaponsNfts, setWeaponsNfts] = useState([]);
  const [loadWeaponsNfts, setLoadWeaponsNfts] = useState(false);
  const [shieldsNfts, setShieldsNfts] = useState([]);
  const [loadShieldsNfts, setLoadShieldsNfts] = useState(false);
  const [repairekitNfts, setRepairekitNfts] = useState([]);
  const [loadRepairekitNfts, setLoadRepairekitNfts] = useState(false);

  const getNfts = async () => {
    const nfts = await getSpaceships();
    setNfts(nfts);
    setLoadNfts(true);
  };
  const getWeaponsNfts = async () => {
    const weaponsNfts = await getWeapons();
    console.log(weaponsNfts);
    setWeaponsNfts(weaponsNfts);
    setLoadWeaponsNfts(true);
  };
  const getShieldsNfts = async () => {
    const shieldsNfts = await getShields();
    console.log(weaponsNfts);
    setShieldsNfts(shieldsNfts);
    setLoadShieldsNfts(true);
  };
  const getRepairekitNfts = async () => {
    const repairekitNfts = await getRepairkits();
    console.log(repairekitNfts);
    setRepairekitNfts(repairekitNfts);
    setLoadRepairekitNfts(true);
  };
  useEffect(() => {
    getNfts();
    getWeaponsNfts();
    getShieldsNfts();
    getRepairekitNfts();
  }, [isConnected, address, chain]);
  const settings = {
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    infinite: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          Padding: '100px 50px',
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const spaceshipOnClick = (item) => {
    const spaceshipobj = {
      name: item.name,
      image: item.image,
      sprite_photo: item.sprite_photo,
      soundLeft: item.sounds[0],
      soundRight: item.sounds[1],
      soundDown: item.sounds[2],
      soundUp: item.sounds[3],
      fireCapacity: item.properties.fireCapacity,
      level: item.properties.level,
      maxFuel: item.properties.maxFuel,
      maxShields: item.properties.maxShields,
      maxWeapons: item.properties.maxWeapons,
      resilience: item.properties.resilience,
      speed: item.properties.speed,
    };
    console.log('Spaceship data : ', spaceshipobj);

    localStorage.setItem('portofolioChosen', JSON.stringify(spaceshipobj));
  };
  return (
    <div className="area-bg-one">
      <HeaderOne />
      <main>
        <Breadcrumb />
        {/* <GameSingleArea/> */}
        <div className="d-flex justify-content-center pt-5 pb-5 mt-5 game-container ">
          <>
            {!isConnected ? (
              <PromptLogin />
            ) : (
              <>
                {nfts.length != 0 ? (
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6 col-md-8">
                        <div className="section-title mb-50">
                          <h2>
                            <span>Your Spaceship</span>
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <Slider
                          className="latest-games-active slick"
                          {...settings}
                        >
                          {nfts.map((item, index) => (
                            <div key={index} className="content">
                              <div className="latest-games-items mb-30">
                                <a
                                  href="/#/game-single"
                                  onClick={() => spaceshipOnClick(item)}
                                >
                                  <div className="latest-games-thumb">
                                    <a>
                                      <img src={item.image} alt="" />
                                    </a>
                                    <div className="content-overlay"></div>
                                  </div>
                                  <div className="content-details fadeIn-bottom">
                                    <p className="content-text">
                                      {
                                        constants[
                                          item.name.split(' ').join('_')
                                        ]
                                      }
                                    </p>
                                  </div>
                                </a>
                                <div className="latest-games-content">
                                  <div className="lg-tag">
                                    <a>space ship</a>
                                  </div>
                                  <h4>
                                    <a
                                    // onClick={() => setStartGame(true)}
                                    >
                                      {item.name} <span></span>
                                    </a>
                                  </h4>
                                </div>
                              </div>
                            </div>
                          ))}
                        </Slider>
                      </div>
                    </div>
                    <>
                      <div className="container">
                        {weaponsNfts.length != 0 && loadWeaponsNfts ? (
                          <>
                            <div className="row">
                              <div className="col-lg-6 col-md-8">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>Your Weapons</span>
                                  </h2>
                                </div>
                              </div>
                            </div>
                            {/* <div className="row">
                                      <div className="col-10"> */}
                            <Slider
                              className="latest-games-active slick"
                              {...settings}
                            >
                              {weaponsNfts.map((item, index) => (
                                <SingleUserOwnedNFT
                                  key={index}
                                  item={item}
                                  type={NFTSTypes.weapon}
                                />
                              ))}
                            </Slider>
                          </>
                        ) : (
                          <>
                            {weaponsNfts.length == 0 && loadWeaponsNfts ? (
                              <div className="container">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>You dont have any Weapons</span>
                                    <h3>
                                      <span>
                                        Buy one from the{' '}
                                        <a href="/#/shop">store</a>
                                      </span>
                                    </h3>
                                  </h2>
                                </div>
                              </div>
                            ) : (
                              <div className="container">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>Loading Your Weapons</span>
                                  </h2>
                                </div>
                                <div className="row justify-content-center"></div>
                              </div>
                            )}
                          </>
                        )}

                        {shieldsNfts.length != 0 && loadShieldsNfts ? (
                          <>
                            <div className="row">
                              <div className="col-lg-6 col-md-8">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>Your Shields</span>
                                  </h2>
                                </div>
                              </div>
                            </div>
                            <Slider
                              className="latest-games-active slick"
                              {...settings}
                            >
                              {shieldsNfts.map((item, index) => (
                                <SingleUserOwnedNFT
                                  key={index}
                                  item={item}
                                  type={NFTSTypes.shield}
                                />
                              ))}
                            </Slider>
                          </>
                        ) : (
                          <>
                            {shieldsNfts.length == 0 && loadShieldsNfts ? (
                              <div className="container">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>You dont have any Shield</span>
                                    <h3>
                                      <span>
                                        Buy one from the{' '}
                                        <a href="/#/shop">store</a>
                                      </span>
                                    </h3>
                                  </h2>
                                </div>
                              </div>
                            ) : (
                              <div className="container">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>Loading Your Shields</span>
                                  </h2>
                                </div>
                                <div className="row justify-content-center"></div>
                              </div>
                            )}
                          </>
                        )}

                        {repairekitNfts.length != 0 && loadRepairekitNfts ? (
                          <>
                            <div className="row">
                              <div className="col-lg-6 col-md-8">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>Your Repaire kits</span>
                                  </h2>
                                </div>
                              </div>
                            </div>
                            <Slider
                              className="latest-games-active slick"
                              {...settings}
                            >
                              {repairekitNfts.map((item, index) => (
                                <SingleUserOwnedNFT
                                  key={index}
                                  item={item}
                                  type={NFTSTypes.repairKit}
                                />
                              ))}
                            </Slider>
                          </>
                        ) : (
                          <>
                            {repairekitNfts.length == 0 &&
                            loadRepairekitNfts ? (
                              <div className="container">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>You dont have any Reapire Kit</span>
                                    <h3>
                                      <span>
                                        Buy one from the{' '}
                                        <a href="/#/shop">store</a>
                                      </span>
                                    </h3>
                                  </h2>
                                </div>
                              </div>
                            ) : (
                              <div className="container">
                                <div className="section-title mb-50">
                                  <h2>
                                    <span>Loading Your Reapire Kit</span>
                                  </h2>
                                </div>
                                <div className="row justify-content-center"></div>
                              </div>
                            )}
                          </>
                        )}

                        {/* </div>
                                    </div> */}
                      </div>
                    </>
                  </div>
                ) : (
                  <>
                    {loadNfts ? (
                      <div className="container">
                        <div className="section-title mb-50">
                          <h2>
                            You don't have any <span> Spaceship</span>
                            <h3>
                              <span>
                                Buy one from the <a href="/#/shop">store</a>
                              </span>
                            </h3>
                          </h2>
                        </div>
                      </div>
                    ) : (
                      <div className="container">
                        <div className="section-title mb-50">
                          <h2>
                            <span>Loading Your Spaceship</span>
                          </h2>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Portfolio;
